import { setAllDropDownFieldsBatch } from "../../../utils/FormFields/FieldsSetting/SetFieldSetting";
import { addFormFields, removeFieldsById } from "../../../utils/FormFields/RemoveFields/handleRemoveFields";
import { EditViewIndividualMemberData } from "../data/EditViewIndividualMember.Data";
import { HideShowAllCurrentEmployeeConfig, HideShowCurrentEmployeeConfig, HideShowInsoleMemberFieldsConfig, HideShowIsBenifitsOfYourCreditorsFieldsConfig, HideShowIsCriminalOffenceFieldsConfig, HideShowOtherQualificationFieldConfig, HideShowProfessionalInfoFieldsConfig, HideShowSupportFileFieldConfig } from "./addHideShowFields";
import { viewIndividualMemberFormDropdownConfigs } from "./setDropdownFields";


/**
 * Handles changes in form fields dynamically based on specific conditions.
 *
 * @param {string} dataFieldName - The name of the field that triggered the change.
 * @param {object} updateFormData - The updated field data object containing new values.
 * @param {object} EditViewIndividualMemberData - The current state and structure of the form.
 * @param {object} allDropDownResponse - Data fetched for dropdown options.
 */
export const handleFieldChange = (dataFieldName, updateFormData, allDropDownResponse) => {
    switch (dataFieldName) {
        case "membershipTypeId": {
            const { membershipTypeId } = updateFormData;

            if (membershipTypeId?.label !== "Associate" || membershipTypeId?.label !== "Honorary Member") {
                /**
               * @param {object} EditViewIndividualMemberData - The form data object.
               * @param {Array<object>} HideShowSupportFileFieldConfig - Fields to add for file uploads.
                @param {string} "relevantDiplomasCertificatesFile" - The ID after which the fields will be added.
               */
                addFormFields(EditViewIndividualMemberData, HideShowSupportFileFieldConfig, "relevantDiplomasCertificatesFile");
            } else {
                /**
               * @param {object} viewIndividualMemberForm - The form data object.
               * @param {Array<string>} ['detailedListAppRoleRespoFile'] - The IDs of fields to remove.
               */
                removeFieldsById(EditViewIndividualMemberData, ['detailedListAppRoleRespoFile']);
            }
            break;

        }

        case "isINSOLMembership": {
            const { isINSOLMembership } = updateFormData;

            // Add or remove fields based on criminal offence status
            if (isINSOLMembership === "no") {
                addFormFields(EditViewIndividualMemberData, HideShowInsoleMemberFieldsConfig, "isINSOLMembership");
                setAllDropDownFieldsBatch(EditViewIndividualMemberData, viewIndividualMemberFormDropdownConfigs, allDropDownResponse);//membershipApplicationFormData
            } else {
                removeFieldsById(EditViewIndividualMemberData, ['reasonId']);
                setAllDropDownFieldsBatch(EditViewIndividualMemberData, viewIndividualMemberFormDropdownConfigs, allDropDownResponse);//membershipApplicationFormData
            }
            break;
        }

        case "iscriminaloffence": {
            const { iscriminaloffence } = updateFormData;

            // Add or remove fields based on criminal offence status
            if (iscriminaloffence === "no") {
                removeFieldsById(EditViewIndividualMemberData, ['criminaloffenceMoreDetails']);
            } else {
                addFormFields(EditViewIndividualMemberData, HideShowIsCriminalOffenceFieldsConfig, "iscriminaloffence");
            }
            break;
        }
        case "isBenifitsOfYourCreditors": {
            const { isBenifitsOfYourCreditors } = updateFormData;

            // Add or remove fields based on creditor benefits status
            if (isBenifitsOfYourCreditors === "no") {
                removeFieldsById(EditViewIndividualMemberData, ['benifitsOfYourCreditorsMoreDetails']);
            } else {
                addFormFields(EditViewIndividualMemberData, HideShowIsBenifitsOfYourCreditorsFieldsConfig, "isBenifitsOfYourCreditors");
            }
            break;
        }
        case "isOtherProfessional": {
            const { isOtherProfessional } = updateFormData;

            // Add or remove fields based on other professional status
            if (isOtherProfessional) {
                addFormFields(EditViewIndividualMemberData, HideShowProfessionalInfoFieldsConfig, "isOtherProfessional");
            } else {
                removeFieldsById(EditViewIndividualMemberData, ['isOtherProfessionalReason']);
            }
            break;
        }
        case "currentlyEmployed": {
            const { currentlyEmployed } = updateFormData;
            if (currentlyEmployed === "no") {
                removeFieldsById(EditViewIndividualMemberData, HideShowCurrentEmployeeConfig);
                setAllDropDownFieldsBatch(EditViewIndividualMemberData, viewIndividualMemberFormDropdownConfigs, allDropDownResponse);//membershipApplicationFormData
            }
            else {
                addFormFields(EditViewIndividualMemberData, HideShowAllCurrentEmployeeConfig, "currentlyEmployed");
                setAllDropDownFieldsBatch(EditViewIndividualMemberData, viewIndividualMemberFormDropdownConfigs, allDropDownResponse);//membershipApplicationFormData
            }
            break;
        }
        case "highestQualificationId": {
            const { highestQualificationId } = updateFormData;

            if (highestQualificationId?.label === "Others") {
                /**
               * @param {object} EditViewIndividualMemberData - The form data object.
               * @param {Array<object>} HideShowOtherQualificationFieldConfig - Fields to add for file uploads.
                @param {string} "highestQualificationId" - The ID after which the fields will be added.
               */
                addFormFields(EditViewIndividualMemberData, HideShowOtherQualificationFieldConfig, "highestQualificationId");
            } else {
                /**
               * @param {object} EditViewIndividualMemberData - The form data object.
               * @param {Array<string>} ['other'] - The IDs of fields to remove.
               */
                removeFieldsById(EditViewIndividualMemberData, ['highestQualificationOthers']);
            }
            break;
        }
        default:
            break;
    }
}

export default handleFieldChange;

export const handleEditFieldChange = (editViewIndividualMemberFormData, allDropDownResponse, apiResponse) => {
    const updateFields = (condition, addConfig, fieldKey, removeIds = []) => {
        if (condition) {
            addFormFields(editViewIndividualMemberFormData, addConfig, fieldKey);
        } else {
            removeFieldsById(editViewIndividualMemberFormData, removeIds);
        }
    };
    updateFields(
        apiResponse?.isCurrentlyEmployed === true || false,
        HideShowCurrentEmployeeConfig,
        "currentlyEmployed",
        HideShowCurrentEmployeeConfig
    );
    // Update fields based on isINSOLMembership
    updateFields(
        !apiResponse?.isINSOLMembership,
        HideShowInsoleMemberFieldsConfig,
        "isINSOLMembership",
        ['reasonId']
    );
    if (!apiResponse?.isINSOLMembership) {
        setAllDropDownFieldsBatch(
            editViewIndividualMemberFormData,
            viewIndividualMemberFormDropdownConfigs,
            allDropDownResponse
        );
    }
    // Update fields based on membershipType
    updateFields(
        //apiResponse?.membershipType !== 1 || apiResponse?.membershipType !== 7,
        ![1].includes(apiResponse?.membershipType),
        HideShowSupportFileFieldConfig,
        "relevantDiplomasCertificatesFile",
        ['detailedListAppRoleRespoFile']
    );

    updateFields(
        !apiResponse?.isCurrentlyEmployed,
        HideShowCurrentEmployeeConfig,
        "currentlyEmployed",
        HideShowAllCurrentEmployeeConfig
    );

    // Update fields based on isCriminalOffence
    updateFields(
        apiResponse?.isCriminalOffence,
        HideShowIsCriminalOffenceFieldsConfig,
        "iscriminaloffence",
        ['criminaloffenceMoreDetails']
    );

    // Update fields based on isAdjudgedBankrupt
    updateFields(
        apiResponse?.isAdjudgedBankrupt,
        HideShowIsBenifitsOfYourCreditorsFieldsConfig,
        "isBenifitsOfYourCreditors",
        ['benifitsOfYourCreditorsMoreDetails']
    );

    // Update fields based on isOtherProfessionalInformation
    updateFields(
        apiResponse?.isOtherProfessionalInformation,
        HideShowProfessionalInfoFieldsConfig,
        "isOtherProfessional",
        ['isOtherProfessionalReason']
    );

    // Update fields based on highestQualificationAttained
    updateFields(
        Number(apiResponse?.highestQualificationAttained) === 8,
        HideShowOtherQualificationFieldConfig,
        "highestQualificationId",
        ['other']
    );
};

